export default __webpack_public_path__ + "static/media/card_l_green.c0b7c583.png";